import styled, { css } from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

import { ZxcvbnScore } from './PasswordStrength.types';

export const PasswordStrengthStyled = styled.div<{ $strength: ZxcvbnScore }>`
  position: relative;
  width: 100%;
  height: 3px;
  background: ${Colors.DarkerMiddle};

  ${ct({
    Dark: css`
      background: ${Colors.DarkerMiddle};
    `,
    Light: css`
      background: ${Colors.Dark};
    `,
  })};

  ${({ $strength }) => {
    if ($strength <= ZxcvbnScore.NoScore) {
      return css`
        display: none;
      `;
    }
  }};

  &:before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;

    ${({ $strength }) => {
      if ($strength < ZxcvbnScore.NoScore) {
        return css`
          width: 0;
        `;
      }

      if ([ZxcvbnScore.TooGuessable, ZxcvbnScore.VeryGuessable].includes($strength)) {
        return css`
          width: 32%;
          background: ${Colors.PinkMiddle};
        `;
      }

      if (ZxcvbnScore.SomewhatGuessable === $strength) {
        return css`
          width: 52%;
          background: ${Colors.OrangeMiddle};
        `;
      }

      if (ZxcvbnScore.SafelyUnguessable === $strength) {
        return css`
          width: 76%;
          background: ${Colors.BlueMiddle};
        `;
      }

      if (ZxcvbnScore.VeryUnguessable === $strength) {
        return css`
          width: 100%;
          background: ${Colors.GreenMiddle};
        `;
      }
    }};
  }
`;
